import React from 'react';

interface Props {
  children: React.ReactNode;
}

const List = ({children}: Props): React.ReactElement => <div className="list">{children}</div>;

export default List;
